// Board layer depths (IMPLEMENTATION §2.6 "Layer model"): floor 0, chutes 10, buildings 20, items 30,
// stall icons 40, highlights 50, board FX 60, Gallery FX 65 (targets pop up to 0.6 cell into the row
// above; confetti overflows ±1 cell). Sub-layers stay inside their band. M10: the Gallery's rail targets and
// the moving-part overlays sit on their building body; the contents indicators above the bars and the gun.
export const DEPTH = {
  floor: 0,
  chute: 10,
  chevron: 11,
  building: 20,
  railTarget: 20.2,
  part: 20.4,
  partGlow: 20.6,
  arrow: 21,
  barBg: 22,
  barFill: 23,
  gun: 24,
  contents: 25,
  contentsTop: 26,
  item: 30,
  stall: 40,
  highlight: 50,
  boardFx: 60,
  galleryFx: 65,
} as const;
